'use client';

// import Link from 'next/link';
import { useFormatter } from 'next-intl';

import type { NotificationItem } from '@/api/backend/contract/Notification';

import { styles } from './UiNotificationTile.styles';

export interface UiNotificationTileProps {
  notification: NotificationItem;
  onClick?: () => void;
}

export function UiNotificationTile({ notification, onClick }: UiNotificationTileProps) {
  const format = useFormatter();
  const slots = styles({ isRead: notification.isRead });

  const time = format.dateTime(new Date(notification.createdAt), {
    hour: '2-digit',
    minute: '2-digit'
  });
  // const t = useTranslations('accountNotifications');
  // const actionLabel = notification.action?.label || t('actionView');
  // const actionUrl = notification.action?.url;

  const content = (
    <>
      <h2 className={slots.title()}>{notification.title}</h2>
      <p className={slots.body()}>{notification.body}</p>
      <div className={slots.footer()}>
        {/* {notification.action ? (
          <span className={slots.action()}>{actionLabel}</span>
        ) : (
          <span />
        )} */}
        <span />
        <time
          className={slots.time()}
          dateTime={notification.createdAt}
        >
          {time}
        </time>
      </div>
    </>
  );

  return (
    // <Link
    //   href="/catalog"
    //   className={slots.base()}
    //   onClick={onClick}
    // >
    //   {content}
    // </Link>
    <button
      type="button"
      className={slots.base()}
      onPointerDown={(event) => event.stopPropagation()}
      onClick={onClick}
    >
      {content}
    </button>
  );
}
